module.exports = __webpack_public_path__ + "img/rec-logo.c38cafd8.svg";